// US-only phone helpers (ticket 125). Storage format is digits-only, 10 digits —
// the same thing backend/models_unified.py normalize_phone() produces.
export const PHONE_PLACEHOLDER = '+1 (555) 555-5555';

// Any string → up to 10 digits. A leading country code 1 is dropped once an
// 11th digit exists ('+1 512 555 0101' and '15125550101' → '5125550101').
export function phoneDigits(raw) {
  let d = String(raw ?? '').replace(/\D/g, '');
  if (d.length > 10 && d[0] === '1') d = d.slice(1);
  return d.slice(0, 10);
}

// Progressive mask for the input while typing. The '+1 ' country code is shown
// so the user sees the full dialable number, but it is never stored (US only):
// '' → '', '5' → '+1 (5', '512' → '+1 (512', '5125' → '+1 (512) 5',
// '512555' → '+1 (512) 555', '5125550' → '+1 (512) 555-0', '5125550101' → '+1 (512) 555-0101'.
export function formatPhoneInput(raw) {
  const d = phoneDigits(raw);
  if (!d) return '';
  if (d.length <= 3) return `+1 (${d}`;
  if (d.length <= 6) return `+1 (${d.slice(0, 3)}) ${d.slice(3)}`;
  return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// Read-only rendering. Exactly 10 digits (or 11 with a leading 1) → '(512) 555-0101';
// anything else is returned trimmed and untouched so legacy/odd data is never mangled.
export function formatPhone(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  let d = s.replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : s;
}

// href for <a>: 'tel:+15125550101' when we have 10 digits, else 'tel:<raw>'.
export function telHref(raw) {
  const d = phoneDigits(raw);
  return d.length === 10 ? `tel:+1${d}` : `tel:${String(raw ?? '').trim()}`;
}
